"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberValidator = void 0;
const validator_1 = require("./validator");
const utils_1 = require("./utils");
class NumberValidator extends validator_1.CommonValidator {
    merge(props) {
        return new NumberValidator({ ...this.props, ...props });
    }
    precision(precision) {
        return this.merge({ precision });
    }
    multipleOf(multipleOf) {
        return this.merge({ multipleOf });
    }
    integer() {
        return this.precision(0);
    }
    min(min) {
        return this.merge({ min });
    }
    max(max) {
        return this.merge({ max });
    }
    minExclusive(minExclusive) {
        return this.merge({ minExclusive });
    }
    maxExclusive(maxExclusive) {
        return this.merge({ maxExclusive });
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [
                this.validateType,
                this.validatePrecision,
                this.validateMultipleOf,
                this.validateMin,
                this.validateMax,
                this.validateMinExclusive,
                this.validateMaxExclusive
            ]
        });
    };
    validateType = async ({ ctx, next }) => {
        if (typeof ctx.value === "number" && !Number.isNaN(ctx.value)) {
            return next();
        }
        ctx.addError({ type: "number" });
    };
    validatePrecision = async ({ rootCtx, ctx, next }) => {
        const precision = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.precision);
        if (precision === undefined ||
            (`${ctx.value}`.split(".")[1] || "").length <= precision) {
            return next();
        }
        ctx.addError({ precision });
    };
    validateMultipleOf = async ({ rootCtx, ctx, next }) => {
        const multipleOf = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.multipleOf);
        if (multipleOf === undefined) {
            return next();
        }
        const v = ctx.value / multipleOf;
        if (Math.floor(v) === v) {
            return next();
        }
        ctx.addError({ multipleOf });
    };
    validateMin = async ({ rootCtx, ctx, next }) => {
        const min = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.min);
        if (min === undefined || ctx.value >= min) {
            return next();
        }
        ctx.addError({ min });
    };
    validateMax = async ({ rootCtx, ctx, next }) => {
        const max = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.max);
        if (max === undefined || ctx.value <= max) {
            return next();
        }
        ctx.addError({ max });
    };
    validateMinExclusive = async ({ rootCtx, ctx, next }) => {
        const minExclusive = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.minExclusive);
        if (minExclusive === undefined || ctx.value > minExclusive) {
            return next();
        }
        ctx.addError({ minExclusive });
    };
    validateMaxExclusive = async ({ rootCtx, ctx, next }) => {
        const maxExclusive = await (0, utils_1.evaluateValue)(rootCtx, ctx, this.props.maxExclusive);
        if (maxExclusive === undefined || ctx.value < maxExclusive) {
            return next();
        }
        ctx.addError({ maxExclusive });
    };
}
exports.NumberValidator = NumberValidator;
